export const dateXAxisPeriodsFormat: Map<PeriodsType, string> = new Map([
	["7D", "DD dd"],
	["1M", "DD MMM"],
	["6M", "DD MMM YY"],
	["1Y", "DD MMM YY"],
	["YTD", "DD MMM YY"],
	["3Y", "DD MMM YY"],
	["5Y", "DD MMM YY"],
	["ALL", " DD MMM YY"],
	["CUSTOM", "DD MMM YY"]
]);

export type PeriodsType = "7D" | "1M" | "6M" | "YTD" | "1Y" | "3Y" | "5Y" | "ALL" | "CUSTOM";
export const PERIODS: PeriodsType[] = ["7D", "1M", "6M", "YTD", "1Y", "ALL"];
